import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Select,
  Grid,
  Flex,
  Icon,
  Text,
  InputGroup,
  InputRightElement,
  useDisclosure,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { FaUser, FaUserShield, FaPlus, FaSync } from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../Globalapi/Globalapi";
// import { StudentContext } from '../../Context/StudentContext';

const Create_student = () => {
  // const { refreshStudents } = useContext(StudentContext);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [bloodGroups, setBloodGroups] = useState([]);
  const [genders, setGenders] = useState([]);
  const [classes, setClasses] = useState([]);

  const [guardians, setGuardians] = useState([]);
  const [filteredGuardians, setFilteredGuardians] = useState([]);
  const [mediums, setMedium] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showGuardianList, setShowGuardianList] = useState(false);
  // const [showNewGuardianForm, setShowNewGuardianForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    date_of_birth: "",
    gender: "",
    blood_group: "",
    class_name: "",
    aadhar_no: "",
    image: "", // Base64 string for image
    medium: "",
    father_name: "",
    father_number: "",
    mother_name: "",
    mother_number: "",
    guardian: "", // Store guardian name
    // username: '',
    // password: '',
    // confirm_password: '',
    guardian_name: "",
    admission_number: "",
    class_id: "", // Store selected class ID
  });

  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/staff/blood_group_master.php`)
      .then((response) => setBloodGroups(response.data.data || []))
      .catch((error) => console.error("Error fetching blood groups:", error));

    axios
      .get(`${BASE_URL}/admin/staff/gender_master.php`)
      .then((response) => setGenders(response.data.data || []))
      .catch((error) => console.error("Error fetching genders:", error));

    axios
      .get(`${BASE_URL}/admin/student/medium_master.php`)
      .then((response) => setMedium(response.data.data || []))
      .catch((error) => console.error("Error fetching blood groups:", error));
  }, []);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));

    if (name === "guardian") {
      fetchGuardians(value); // Fetch the guardians based on name input
    } else if (name === "class_id") {
      // Find the selected class object
      const selectedClass = classes.find((cls) => cls.id === value);

      setFormData((prevState) => ({
        ...prevState,
        class_id: value, // Store class ID
        class_name: selectedClass ? selectedClass.class : "", // Store class name
      }));
    }
  };

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/class_master.php`
        );
        console.log("clas res", response);

        setClasses(response.data.data || []);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClasses();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((prevState) => ({
        ...prevState,
        image: reader.result,
      }));
    };
    if (file) reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    // const { guardian, class_name, ...rest } = formData;
    // const dataToSubmit = {
    //   ...rest,
    //   guardian: formData.guardian,
    //   class_name,
    //   school_id: sessionStorage.getItem("school_id"),
    //   pass: sessionStorage.getItem("user_id"),
    // };
    const { guardian, class_name } = formData;
    const dataToSubmit = {
      ...formData,
      guardian: formData.guardian,
      class_name,
      school_id: sessionStorage.getItem("school_id"),
      pass: sessionStorage.getItem("user_id"),
    };
    console.log("sub@@", dataToSubmit);
    try {
      const response = await axios.post(
        `${BASE_URL}/staff/students/add_student.php`,
        dataToSubmit
      );
      console.log("API Response:", response.data); // Log the response to verify the structure
      alert(response.data);
      // Adjust the success condition based on actual response format
      if (response.data && response.data.success) {
        toast({
          title: "Success",
          description: "Data submitted successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        // Reset form after successful submission
        setFormData({
          name: "",
          email: "",
          address: "",
          date_of_birth: "",
          gender: "",
          class_name: "",
          blood_group: "",
          aadhar_no: "",
          image: "",
          medium: "",
          father_name: "",
          father_number: "",
          mother_name: "",
          mother_number: "",
          guardian: "",
          admission_number: "",
          guardian_name: "",
        });
      } else {
        // Handle case where API returns success as false or there is an error message
        throw new Error(response.data.message || "Failed to submit data");
      }
    } catch (error) {
      // Log the error for debugging
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message
      );
      setFormData({
        name: "",
        email: "",
        address: "",
        date_of_birth: "",
        gender: "",
        blood_group: "",
        aadhar_no: "",
        image: "",
        medium: "",
        father_name: "",
        father_number: "",
        mother_name: "",
        mother_number: "",
        guardian: "",
        admission_number: "",
      });
      // Display error toast
      toast({
        title: "Error",
        description: error.message || "There was an error submitting the data.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const fetchGuardians = async (name) => {
    if (name.length < 2) {
      setFilteredGuardians([]);
      setShowGuardianList(false);
      return;
    }
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/guardian/view_guardian.php`,
        {
          params: {
            school_id: sessionStorage.getItem("school_id"),
            SEARCH_WITH: name,
          },
        }
      );
      if (response.data && response.data.data) {
        setFilteredGuardians(response.data.data);
        setShowGuardianList(true);
      } else {
        setFilteredGuardians([]);
        setShowGuardianList(false);
      }
    } catch (error) {
      console.error("Error fetching guardians:", error);
      setFilteredGuardians([]);
      setShowGuardianList(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setFormData((prevState) => ({ ...prevState, guardian_name: value })); // Update the display name
    fetchGuardians(value);
  };

  const handleGuardianSelect = (guardian) => {
    setFormData((prevState) => ({
      ...prevState,
      guardian: guardian.id,
      guardian_name: guardian.name,
    }));
    setSearchTerm(guardian.name);
    setShowGuardianList(false);
  };

  const handleAddNewGuardianClick = () => {
    // Call the onOpen function to open the modal
    onOpen();
    setShowGuardianList(false);
  };

  const handleGuardianAdded = (newGuardian) => {
    setFormData((prevState) => ({
      ...prevState,
      guardian: newGuardian.id,
      guardian_name: newGuardian.name,
    }));
    // setShowNewGuardianForm(false);
  };

  const uniqueGuardians = Array.from(
    new Set(filteredGuardians.map((g) => g.id))
  ).map((id) => filteredGuardians.find((g) => g.id === id));

  return (
    <Box borderRadius="md" mx="auto">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Add Student</h1>
            <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md" // Applies a medium shadow
                backgroundColor="white"
                fontSize="11px"
                onClick={() => {
                  // Add refresh functionality here
                  console.log("Refresh button clicked");
                }}
              >
                <FaSync color="#515B73" />
              </Button>

              {/* <div className="export-dropdown">
                                <Button className="export-button" backgroundColor='white' fontSize='11px' boxShadow="md">
                                    <FaPrint color='#515B73' />
                                    Print PDF
                                </Button>
                            </div> */}
            </div>
          </div>

          <div className="breadcrumb">
            <span>Staff</span> / <span>Students</span> /{" "}
            <span>Add Students </span>
          </div>
        </div>
        <Box p={6}>
          <VStack spacing={4} align="stretch">
            <Box width="100%" bg="#F2F5FF" p={1} borderRadius="md">
              <Flex align="center" mb={4} mt={2} ml={2}>
                <Icon as={FaUser} boxSize={6} color="teal" mr={2} />
                <Text fontSize="lg" fontWeight="bold">
                  Personal Information
                </Text>
              </Flex>
            </Box>
            <Grid
              templateColumns={{ base: "1fr", lg: "repeat(4, 1fr)" }}
              gap={6}
              mb={6}
              p={2}
            >
              <FormControl id="name" isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="email" isRequired>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="address" isRequired>
                <FormLabel>Address</FormLabel>
                <Input
                  type="text"
                  placeholder="Address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="date_of_birth" isRequired>
                <FormLabel>Date of Birth</FormLabel>
                <Input
                  type="date"
                  name="date_of_birth"
                  value={formData.date_of_birth}
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>
            <Grid
              templateColumns={{ base: "1fr", lg: "repeat(4, 1fr)" }}
              gap={6}
              mb={6}
              p={2}
            >
              <FormControl id="gender" isRequired>
                <FormLabel>Gender</FormLabel>
                <Select
                  placeholder="Select Gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  {genders.map((gender) => (
                    <option key={gender.id} value={gender.id}>
                      {gender.gender}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl id="class" isRequired>
                <FormLabel>Select Class</FormLabel>
                <Select
                  placeholder="Select Class"
                  name="class_id"
                  value={formData.class_id}
                  onChange={handleChange}
                >
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="blood_group" isRequired>
                <FormLabel>Blood Group</FormLabel>
                <Select
                  placeholder="Select Blood Group"
                  name="blood_group"
                  value={formData.blood_group}
                  onChange={handleChange}
                >
                  {bloodGroups.map((bloodGroup) => (
                    <option key={bloodGroup.id} value={bloodGroup.id}>
                      {bloodGroup.group}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="aadhar_no">
                <FormLabel>Aadhar No</FormLabel>
                <Input
                  placeholder="Aadhar No"
                  value={formData.aadhar_no}
                  name="aadhar_no"
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>

            {/* <Divider borderColor="gray.300" borderStyle="dotted" /> */}

            <Box>
              <Grid
                templateColumns={{ base: "1fr", lg: "repeat(4, 1fr)" }}
                gap={6}
                mb={6}
                p={2}
              >
                <FormControl id="admission_number" isRequired>
                  <FormLabel>Admission No</FormLabel>
                  <Input
                    placeholder="Admission No"
                    value={formData.admission_number}
                    name="admission_number"
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="image">
                  <FormLabel>Profile Image</FormLabel>
                  <Input type="file" onChange={handleImageChange} />
                </FormControl>

                <FormControl id="medium" isRequired>
                  <FormLabel>Medium</FormLabel>
                  <Select
                    placeholder="Select Medium"
                    name="medium"
                    value={formData.medium}
                    onChange={handleChange}
                  >
                    {mediums.map((medium) => (
                      <option key={medium.id} value={medium.id}>
                        {medium.caption}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl id="father_name" isRequired>
                  <FormLabel>Father Name</FormLabel>
                  <Input
                    placeholder="Father Name"
                    name="father_name"
                    value={formData.father_name}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="mother_name" isRequired>
                  <FormLabel>Mother Name</FormLabel>
                  <Input
                    placeholder="Mother Name"
                    name="mother_name"
                    value={formData.mother_name}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="father_number" isRequired>
                  <FormLabel>Father Number</FormLabel>
                  <Input
                    placeholder="Father Number"
                    name="father_number"
                    value={formData.father_number}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl id="mother_number" isRequired>
                  <FormLabel>Mother Number</FormLabel>
                  <Input
                    placeholder="Mother Number"
                    name="mother_number"
                    value={formData.mother_number}
                    onChange={handleChange}
                  />
                </FormControl>

                {/* <FormControl id="guardian_id" isRequired>
                  <FormLabel>Guardian Name</FormLabel>

                  <Input
                    placeholder="Search Guardian"
                    onChange={(e) => {
                      setSearchTerm(e.target.value); // Update search term state
                      fetchGuardians(e.target.value); // Fetch matching guardians based on input
                    }}
                    value={searchTerm} // Display the current search term
                    mb={2}
                  />

                  <Select
                    placeholder="Select Guardian"
                    name="guardian"
                    value={formData.guardian} // Use guardian for submission
                    onChange={(e) => {
                      if (e.target.value === "add_new") {
                        onOpen(); // Handle adding a new guardian
                      } else {
                        const selectedGuardian = guardians.find(
                          (g) => g.id === e.target.value
                        );
                        setFormData((prevState) => ({
                          ...prevState,
                          guardian: selectedGuardian ? selectedGuardian.id : "", // Store only guardian_id as guardian
                        }));
                      }
                    }}
                  >
                    {filteredGuardians.map((guardian) => (
                      <option key={guardian.id} value={guardian.id}>
                        {guardian.name}
                      </option>
                    ))}
                    <option value="add_new">Add New Guardian</option>
                  </Select>
                </FormControl> */}

                <Box position="relative">
                  <FormControl id="guardian_id" isRequired>
                    <FormLabel>Guardian Name</FormLabel>
                    <InputGroup>
                      <Input
                        placeholder="Search Guardian"
                        onChange={handleSearchChange}
                        value={formData.guardian_name}
                        onFocus={() => setShowGuardianList(true)}
                      />
                      <InputRightElement width="4.5rem">
                        <Button
                          h="1.75rem"
                          size="sm"
                          onClick={handleAddNewGuardianClick}
                          colorScheme="teal"
                          px={2}
                        >
                          <FaPlus />
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                  </FormControl>
                  {/* {showGuardianList && filteredGuardians.length > 0 && (
                    <Box
                      position="absolute"
                      zIndex={10}
                      top="100%"
                      mt={1}
                      left={0}
                      right={0}
                      bg="white"
                      border="1px"
                      borderColor="gray.200"
                      borderRadius="md"
                      boxShadow="lg"
                      maxH="200px"
                      overflowY="auto"
                    >
                      {filteredGuardians.map((guardian) => (
                        <Button
                          key={guardian.id}
                          onClick={() => handleGuardianSelect(guardian)}
                          variant="ghost" // Use a ghost variant for a clean look
                          w="100%" // Make it span the full width
                          justifyContent="flex-start" // Align text to the left
                          _hover={{ bg: "gray.100" }}
                        >
                          {guardian.name}
                        </Button>
                      ))}
                    </Box>
                  )} */}
                  {showGuardianList && filteredGuardians.length > 0 && (
                    <Box
                      position="absolute"
                      zIndex={10}
                      top="100%"
                      mt={1}
                      left={0}
                      right={0}
                      bg="white"
                      border="1px"
                      borderColor="gray.400"
                      // borderRadius="md"
                      boxShadow="lg"
                      maxH="200px"
                      overflowY="auto"
                    >
                      {uniqueGuardians.map((guardian) => (
                        <Button
                          key={guardian.id}
                          onClick={() => handleGuardianSelect(guardian)}
                          variant="ghost"
                          w="100%"
                          justifyContent="flex-start"
                          _hover={{ bg: "gray.200" }}
                        >
                          {guardian.name}
                        </Button>
                      ))}
                    </Box>
                  )}
                  <AddGuardianModal onGuardianAdded={handleGuardianAdded} />
                  {/* )} */}
                </Box>
              </Grid>
            </Box>

            <Divider borderColor="gray.300" borderStyle="dotted" />
            {/* <Box width="100%" bg="#e9edf4" p={1} borderRadius="md">
                    <Flex align="center" mb={4} mt={2} ml={2}>
                        <Icon as={FaUserShield} boxSize={6} color="white" mr={2} />
                        <Text fontSize="lg" fontWeight="bold">Security Details</Text>
                    </Flex>
                </Box>

                <Grid templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }} gap={6} mb={6} p={2}>
                    <FormControl id="username" isRequired>
                        <FormLabel>Username</FormLabel>
                        <Input placeholder="Username" name="username" value={formData.username} onChange={handleChange} />
                    </FormControl>

                    <FormControl id="password" isRequired>
                        <FormLabel>Password</FormLabel>
                        <Input type="password" placeholder="Password" name="password" value={formData.password} onChange={handleChange} />
                    </FormControl>

                    <FormControl id="confirm_password" isRequired>
                        <FormLabel>Confirm Password</FormLabel>
                        <Input type="password" placeholder="Confirm Password" name="confirm_password" value={formData.confirm_password} onChange={handleChange} />
                    </FormControl>
                </Grid> */}

            <AddGuardianModal isOpen={isOpen} onClose={onClose} />

            <Button colorScheme="teal" onClick={handleSubmit}>
              Submit
            </Button>
          </VStack>
        </Box>
      </div>
    </Box>
  );
};

const AddGuardianModal = ({ isOpen, onClose }) => {
  const [nations, setNations] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [guardianFormData, setGuardianFormData] = useState({
    name: "",
    address: "",
    email: "",
    contact_no: "",
    nation: "",
    state: "",
    relation: "",
    district: "",
    place: "",
    username: "",
    password: "",
    confirm_password: "",
  });
  const toast = useToast();

  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/staff/nation_master.php`)
      .then((response) => {
        setNations(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching nations:", error));
  }, []);

  useEffect(() => {
    if (guardianFormData.nation) {
      axios
        .get(`${BASE_URL}/admin/staff/state_master.php`)
        .then((response) => {
          const filteredStates = response.data.data.filter(
            (state) => state.nation_id === guardianFormData.nation
          );
          setStates(filteredStates);
        })
        .catch((error) => console.error("Error fetching states:", error));
    } else {
      setStates([]);
      setDistricts([]);
    }
  }, [guardianFormData.nation]);

  useEffect(() => {
    if (guardianFormData.state) {
      // Use POST request since the PHP script expects it
      axios
        .post(
          `${BASE_URL}/admin/staff/district_master.php`,
          { state_id: guardianFormData.state }, // Pass state_id in the body
          {
            headers: {
              "Content-Type": "application/json", // Ensure proper headers
            },
          }
        )
        .then((response) => {
          if (response.data && response.data.data) {
            setDistricts(response.data.data); // Set districts from response
          } else {
            setDistricts([]); // Clear districts if no data
            console.error("Districts data is empty or undefined:", response);
          }
        })
        .catch((error) => console.error("Error fetching districts:", error));
    } else {
      setDistricts([]); // Clear districts if no state is selected
    }
  }, [guardianFormData.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGuardianFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/guardian/create_guardian.php`,
        {
          ...guardianFormData,
          school_id: sessionStorage.getItem("school_id"), // School ID

          pass: sessionStorage.getItem("user_id"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("====================================");
      console.log(response);
      console.log("====================================");

      if (response.data.success === false) {
        toast({
          title: "Error",
          description: response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Success",
          description: response.data.message,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        onClose();
      }
    } catch (error) {
      console.error(
        "Error creating guardian:",
        error.response ? error.response.data : error.message
      );
      toast({
        title: "Error",
        description:
          "There was an error creating the guardian. " +
          (error.response?.data?.message || error.message),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Guardian Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl id="name" isRequired mb={4}>
            <FormLabel>Name</FormLabel>
            <Input
              name="name"
              value={guardianFormData.name}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="address" isRequired mb={4}>
            <FormLabel>Address</FormLabel>
            <Input
              name="address"
              value={guardianFormData.address}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="email" isRequired mb={4}>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              name="email"
              value={guardianFormData.email}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="relation" isRequired mb={4}>
            <FormLabel>Relation</FormLabel>
            <Input
              name="relation"
              value={guardianFormData.relation}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="contact_no" isRequired mb={4}>
            <FormLabel>Contact No</FormLabel>
            <Input
              name="contact_no"
              value={guardianFormData.contact_no}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="nation" isRequired mb={4}>
            <FormLabel>Nation</FormLabel>
            <Select
              name="nation"
              value={guardianFormData.nation}
              onChange={handleChange}
            >
              <option value="">Select Nation</option>
              {nations.map((nation) => (
                <option key={nation.id} value={nation.id}>
                  {nation.nation}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl id="state" isRequired mb={4}>
            <FormLabel>State</FormLabel>
            <Select
              name="state"
              value={guardianFormData.state}
              onChange={handleChange}
              disabled={!guardianFormData.nation}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.state}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl id="district" isRequired mb={4}>
            <FormLabel>District</FormLabel>
            <Select
              name="district"
              value={guardianFormData.district}
              onChange={handleChange}
              disabled={!guardianFormData.state}
            >
              <option value="">Select District</option>
              {districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.district}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl id="place" isRequired mb={4}>
            <FormLabel>Place</FormLabel>
            <Input
              name="place"
              value={guardianFormData.place}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="username" isRequired mb={4}>
            <FormLabel>Username</FormLabel>
            <Input
              name="username"
              value={guardianFormData.username}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="password" isRequired mb={4}>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              name="password"
              value={guardianFormData.password}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl id="confirm_password" isRequired mb={4}>
            <FormLabel>Confirm Password</FormLabel>
            <Input
              type="password"
              name="confirm_password"
              value={guardianFormData.confirm_password}
              onChange={handleChange}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="teal" mr={3} onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Create_student;
